module.exports = __webpack_public_path__ + "7a9d1901f9945a7916140d9e89f1315f.MP3";